export const DAYOFF_READ_REQUEST = 'DAYOFF_READ_REQUEST';
export const DAYOFF_READ_SUCCESS = 'DAYOFF_READ_SUCCESS';
export const DAYOFF_READ_FAIL = 'DAYOFF_READ_FAIL';
export const DAYOFF_SAVE_REQUEST = 'DAYOFF_SAVE_REQUEST';
export const DAYOFF_SAVE_SUCCESS = 'DAYOFF_SAVE_SUCCESS';
export const DAYOFF_SAVE_FAIL = 'DAYOFF_SAVE_FAIL';